import React from 'react';

const TwilioIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M23.9738 41.682C14.2228 41.682 6.318 33.7772 6.318 24.0265C6.318 14.2755 14.2228 6.37092 23.9738 6.37092C33.7245 6.37092 41.6291 14.2755 41.6291 24.0265C41.6291 33.7772 33.7245 41.682 23.9738 41.682V41.682ZM23.9738 0.0527344C10.7334 0.0527344 0 10.7864 0 24.0265C0 37.2668 10.7334 48 23.9738 48C37.2139 48 47.9473 37.2668 47.9473 24.0265C47.9473 10.7864 37.2139 0.0527344 23.9736 0.0527344H23.9738Z"
      fill="#CF272D"
    />
    <path
      d="M24.9592 18.056C24.9592 15.3031 27.1911 13.0713 29.9441 13.0713C32.6972 13.0713 34.9288 15.3031 34.9288 18.056C34.9288 20.8092 32.6972 23.0409 29.9441 23.0409C27.1911 23.0409 24.9592 20.8092 24.9592 18.056V18.056ZM24.9592 29.9971C24.9592 27.2442 27.1911 25.0122 29.9441 25.0122C32.6972 25.0122 34.9288 27.2442 34.9288 29.9971C34.9288 32.7502 32.6972 34.982 29.9441 34.982C27.1911 34.982 24.9592 32.7502 24.9592 29.9971V29.9971ZM13.0183 29.9971C13.0183 27.2442 15.2503 25.0122 18.0032 25.0122C20.7562 25.0122 22.9881 27.2442 22.9881 29.9971C22.9881 32.7502 20.7562 34.982 18.0032 34.982C15.2503 34.982 13.0183 32.7502 13.0183 29.9971ZM13.0183 18.0562C13.0183 15.3031 15.2503 13.0715 18.0032 13.0715C20.7562 13.0715 22.9881 15.3031 22.9881 18.0562C22.9881 20.8094 20.7562 23.041 18.0032 23.041C15.2503 23.041 13.0183 20.8094 13.0183 18.0562Z"
      fill="#CF272D"
    />
  </svg>
);

export default TwilioIcon;
